import { gql } from '@apollo/client';
import type * as Types from './Types';

export type BaseTransactionFragment = {
  _id: string;
  blockNumber: number;
  amount: string;
  rate: number;
  timestamp: string;
  transactionId: string;
  avaxAmount?: string | null;
  from: string;
};

export const BaseTransactionFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseTransaction on Transaction {
    _id
    blockNumber
    amount
    rate
    timestamp
    transactionId
    avaxAmount
    from
  }
`;
